import { render, staticRenderFns } from "./PublicMenu.CO.UK.vue?vue&type=template&id=5620d4be"
import script from "./PublicMenu.CO.UK.vue?vue&type=script&lang=js"
export * from "./PublicMenu.CO.UK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDivider,
  VIcon,
  VList,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileTitle,
})
